// extracted by mini-css-extract-plugin
export default {"input":"Input_input__HcKTV","error":"Input_error__miKdT"};